import { render } from "./CustomerLogin.vue?vue&type=template&id=1d977ff2&scoped=true"
import script from "./CustomerLogin.vue?vue&type=script&lang=js"
export * from "./CustomerLogin.vue?vue&type=script&lang=js"

import "./CustomerLogin.vue?vue&type=style&index=0&id=1d977ff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d977ff2"]])

export default __exports__